import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import AboutSection from "./components/AboutSection";
import ServicesSection from "./components/ServicesSection";
import FeaturesSection from "./components/FeaturesSection";
import PartnersSection from "./components/PartnersSection";
import CtaSection from "./components/CtaSection";
import GpuTableSection from "./components/GpuTableSection";
import ContactSection from "./components/ContactSection";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <AboutSection />
        <ServicesSection />
        <FeaturesSection />
        <PartnersSection />
        <CtaSection />
        <GpuTableSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}